export enum MensagemTipo {
  ERRO,
  SUCESSO,
  AVISO,
}
